import BootstrapBadge from "react-bootstrap/Badge";
import PropTypes from "prop-types";
import classNames from "classnames";
import IconSvg from "../IconSvg";

// variants: light-primary, light-secondary, light-dark, light-tertiary, primary, secondary, dark, tertiary
function Badge({ children, iconName, variant = "light-primary", className, ...other }) {
  return (
    <div>
      <BootstrapBadge
        {...other}
        bg=""
        className={classNames(`badge-${variant}`, className)}
      >
        <div className="d-flex align-items-center">
          {iconName && (
            <div className="badge-icon">
              <IconSvg name={iconName} />
            </div>
          )}
          <p className="mb-0 font-size-sm font-weight-normal">{children}</p>
        </div>
      </BootstrapBadge>
    </div>
  );
}

Badge.propTypes = {
  iconName: PropTypes.string,
  variant: PropTypes.string,
};

export default Badge;
